import { useEffect } from "react";
import { useAuthStore } from "./atoms/user.auth.store";
import Router from "./router/router";

function App() {
  const { login } = useAuthStore();

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    const userId = localStorage.getItem("userId");
    const role = localStorage.getItem("role") as "user" | "admin" | null;

    if (token && userId && role) {
      login(userId, role, token);
    }
  }, []);

  return (
    <div>
      <Router />
    </div>
  );
}

export default App;
